export function onceAny( target: Document | HTMLElement, eventNames: string[], callback: ( event: Event ) => void ) {
    let fired = false;

    const cleanup = () => {
        for ( const eventName of eventNames ) {
            target.removeEventListener( eventName, handler );
        }
    };

    const handler = ( event: Event ) => {
        if ( fired ) {
            return;
        }

        fired = true;

        cleanup();

        callback( event );
    };

    for ( const eventName of eventNames ) {
        target.addEventListener( eventName, handler, {
            passive: true,
            once: true,
        } );
    }

    return cleanup;
}
